import React from 'react';

import FormSwitchSelector from './FormSwitchSelector';

type Props = {
    field: string;
    currentValue: string | number | boolean;
    label: string | JSX.Element;
    error: string;
    handleChange: (value: string | number) => void;
    required?: boolean;
    trueText?: string;
    falseText?: string;
};

function FormBoolean({
    field,
    currentValue,
    label,
    trueText,
    falseText,
    error,
    handleChange,
    required = false,
}: Props) {
    const options = [
        {
            label: falseText ?? 'No',
            value: '0',
            selectedBackgroundColor: '#de1a24',
        },
        {
            label: trueText ?? 'Yes',
            value: '1',
            selectedBackgroundColor: '#3f8f29',
        },
    ];

    return (
        <FormSwitchSelector
            label={label}
            handleChange={handleChange}
            options={options}
            currentValue={currentValue}
            required={required}
            field={field}
            error={error ?? undefined}
        />
    );
}

export default FormBoolean;
